export default {
  title: 'Modifiers',
  master_title: 'Brand mode - Modifiers',
  products_creation_disabled:
    'Due to active integration with {{integration}}, new products creation is not allowed. If you need to change the menu, please make the changes in {{integration}} and sync the menu.',
  labels: {
    select_all: 'Select all',
  },
  buttons: {
    add_modifier: 'Add modifier',
    delete_selected: 'Delete selected',
    refresh: 'Refresh',
  },
  toasts: {
    failed_to_load_data: 'Failed to load data',
  },
};
